import { Brand } from "effect"
import { Link as RRLink, type LinkProps } from "react-router"

export const Link = (props: Link.Props) => {
  return <RRLink viewTransition {...props} />
}

export type Route = Brand.Branded<string, "Slander/Route">
const Route = Brand.nominal<Route>()

// TODO: brand these ID's
export const Routes = {
  // auth
  verifyOtp: Route("/auth/verify-otp"),
  resendOtp: Route("/auth/resend-otp"),
  authenticate: Route("/auth/authenticate"),
  logout: Route("/auth/logout"),

  // profile
  profile: Route("/profile"),
}

namespace Link {
  export type Props = Omit<LinkProps, "to"> & {
    to: Route
  }
}
